/**
 * GENERATED FILE. Do not edit.
 *
 * Source: packages/shared/registry/purposes.json
 * Rebuild: bun run registry:build
 */

import type { ValueTypeId } from './value-types';

/** The eight engine questions. Mirrors the app.purpose enum in Postgres. */
export const PURPOSE_IDS = [
  'title',
  'time_axis',
  'measure',
  'sign',
  'board_axis',
  'focused_input',
  'parent',
  'root',
  'party',
  'joined_on',
  'left_on',
  'charge_plan',
] as const;

export type PurposeId = (typeof PURPOSE_IDS)[number];

export type Purpose = {
  readonly id: PurposeId;
  readonly what_it_drives: string;
  /** The value types that may answer this question. */
  readonly answered_by: readonly ValueTypeId[];
  /** True only where app.record_binding.const_num may answer instead of a field. */
  readonly const_allowed: boolean;
};

export const PURPOSES: { readonly [K in PurposeId]: Purpose } = {
  'title': { id: 'title', what_it_drives: 'the human name of the row', answered_by: ['text', 'long_text', 'phone', 'select', 'reference'], const_allowed: false },
  'time_axis': { id: 'time_axis', what_it_drives: 'list grouping, date filters, the calendar view', answered_by: ['date', 'datetime'], const_allowed: false },
  'measure': { id: 'measure', what_it_drives: 'the number the summary totals', answered_by: ['money', 'number', 'quantity', 'formula', 'rollup'], const_allowed: false },
  'sign': { id: 'sign', what_it_drives: 'in or out, when the measure is unsigned', answered_by: ['number', 'boolean', 'select'], const_allowed: true },
  'board_axis': { id: 'board_axis', what_it_drives: 'the board view columns', answered_by: ['select', 'reference', 'boolean'], const_allowed: false },
  'focused_input': { id: 'focused_input', what_it_drives: 'the field that opens large, with the keypad', answered_by: ['money', 'number', 'quantity', 'text', 'long_text', 'phone', 'select', 'reference', 'date', 'datetime'], const_allowed: false },
  'parent': { id: 'parent', what_it_drives: 'the entry or line a line belongs to, made by the server and never edited', answered_by: ['reference'], const_allowed: false },
  'root': { id: 'root', what_it_drives: 'the entry at the top of a line\'s tree, for reach, search, delete and counts', answered_by: ['reference'], const_allowed: false },
  'party': { id: 'party', what_it_drives: 'a list whose rows owe or are owed money: a posting rule\'s party role points at it (L20 of docs/plans/ledger.md); bound to the list\'s title field', answered_by: ['text'], const_allowed: false },
  'joined_on': { id: 'joined_on', what_it_drives: 'the day a party row became active, which opens its party period (L22)', answered_by: ['date'], const_allowed: false },
  'left_on': { id: 'left_on', what_it_drives: 'the day a party row stopped being active, which closes its party period (L22)', answered_by: ['date'], const_allowed: false },
  'charge_plan': { id: 'charge_plan', what_it_drives: 'the plan a party row is billed on by a charge run (L23)', answered_by: ['reference'], const_allowed: false },
};

export function isPurposeId(value: string): value is PurposeId {
  return (PURPOSE_IDS as readonly string[]).includes(value);
}
